import React from 'react'

const PaulWright = () =>
  <div className="page bio">
    Paul Wright
  </div>

export default PaulWright
